import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="frame-focus" on a catalogue page's lazy frame (catalogue/_rows). The "Mais resultados"
// link sits inside the frame that Turbo fills, so a keyboard reader who tabs to it loads the next page and loses the
// link with it; focus goes to the first thing the page drew, where the reader was.
export default class extends Controller<HTMLElement> {
	hadFocus = false;

	remember(event: Event) {
		if (event.target === this.element) this.hadFocus = this.element.contains(document.activeElement);
	}

	restore(event: Event) {
		if (event.target !== this.element || !this.hadFocus) return;
		this.hadFocus = false;
		this.element.querySelector<HTMLElement>("a[href], button")?.focus();
	}
}
